//@flow
//Core
import React, { useState } from 'react';
import get from 'lodash.get';
import { Container, Box } from '@material-ui/core';
import formatDate from 'date-format';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
// //Local
import { Layout } from '../components';
import {
  BreadcrumbsSec,
  ArticleSec,
  AuthorSec,
  RecommendSec,
} from '../components/Column/Article';

import { filterRecommendedCardsForPublish } from '../components/mediaCenterSections/utils';
import { getOgData } from '../utils';

import styles from '../styles/pages/column.module.scss';

export const query = graphql`
  query($tagsId: [String], $contentfulId: String) {
    allContentfulComponentArticle(
      limit: 1000
      filter: {
        tags: { elemMatch: { id: { in: $tagsId } } }
        contentful_id: { ne: $contentfulId }
      }
    ) {
      edges {
        node {
          title
          subtitle
          tags {
            title
          }
          contentful_id
          date
          blogSection {
            urlKey
          }
          previewImage {
            file {
              url
            }
          }
          tags {
            title
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        ogImage
        twitterImage
        siteUrl
      }
    }
  }
`;

const Article = ({
  pageContext,
  data,
  location,
}: {
  pageContext: Object,
  data: Object,
  location: Object,
}) => {
  const [imgPopupState, setImgPopupState] = useState({
    isOpen: false,
    url: null,
  });

  const sessionUrl = get(pageContext, 'blogSection.urlKey');
  const breadcrumbs = [
    {
      title: 'トップ',
      url: '/',
    },
    {
      title: 'コラム',
      url: '/column/',
    },
    {
      title: get(pageContext, 'title'),
    },
  ];
  const recommendedArticles = filterRecommendedCardsForPublish(
    get(data, 'allContentfulComponentArticle.edges', [])
  );

  const handleImgClick = (event) => {
    setImgPopupState({
      isOpen: true,
      url: event.target.src,
    });
  };

  const handleClosePopup = () => {
    setImgPopupState({
      isOpen: false,
      url: null,
    });
  };

  return (
    <Layout>
      <Helmet
        title={get(pageContext, 'title')}
        meta={getOgData({
          img: get(pageContext, 'previewImage'),
          title: get(pageContext, 'title'),
          siteMetadata: get(data, 'site.siteMetadata'),
        })}
      />
      {/* <TopBanner bgImg={banner} textAlign="center">
      </TopBanner> */}
      <Box className={styles.articlePage}>
        <Box className={styles.articlePageBg} />
        <Container maxWidth="md">
          <Box className={styles.paper}>
            <BreadcrumbsSec
              items={breadcrumbs}
              tag={get(pageContext, 'tags[0]', {})}
            />
            <ArticleSec
              title={get(pageContext, 'title')}
              subtitle={get(pageContext, 'subtitle')}
              date={formatDate(
                'yyyy/MM/dd',
                new Date(
                  get(pageContext, 'date') || get(pageContext, 'createdAt')
                )
              )}
              author={get(pageContext, 'author')}
              tags={get(pageContext, 'tags', [])}
              content={get(pageContext, 'content.json')}
              imgPopupState={imgPopupState}
              handleImgClick={handleImgClick}
              handleClosePopup={handleClosePopup}
              shareUrl={location.href}
              sessionUrl={sessionUrl}
            />
            {get(pageContext, 'authorBlock') && (
              <AuthorSec
                image={get(pageContext, 'authorBlock.image.file.url')}
                name={get(pageContext, 'authorBlock.name')}
                surname={get(pageContext, 'authorBlock.surname')}
                jobTitle={get(pageContext, 'authorBlock.jobTitle')}
                description={get(pageContext, 'authorBlock.description')}
              />
            )}
          </Box>
          {!!recommendedArticles.length && (
            <RecommendSec recommendedArticles={recommendedArticles} />
          )}
        </Container>
      </Box>
    </Layout>
  );
};

export default Article;
